module.exports = __webpack_public_path__ + "static/img/item-7-1-big.de2f222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-7-1-big.jpg
// module id = hJIb
// module chunks = 2